import { Box } from '@ovComponents/1-primative/box/box';
import type { ReactNode } from 'react';

type SnapshotCardGridProps = {
  children: ReactNode;
  /** Gap between grid cells in MUI spacing units (default 1.5). */
  gap?: number;
};

/**
 * SnapshotCardGrid — a responsive layout wrapper for a row of SnapshotCards.
 *
 * Stacks vertically on narrow viewports and switches to a three-column grid
 * at 1280 px, per the proposal's UAC for the home-page widget.
 *
 * Breakpoint convention: 1280 px is feature-local to this component. It is
 * intentionally NOT migrated into the global `gridLayout.ts` breakpoints
 * (which use MUI's `lg: 1200` for `react-grid-layout`). Do not change
 * `gridLayout.ts` to accommodate this feature.
 */
export const SnapshotCardGrid = ({
  children,
  gap = 1.5,
}: SnapshotCardGridProps): JSX.Element => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap,
      '@media (min-width:1280px)': { gridTemplateColumns: 'repeat(3, 1fr)' },
    }}
  >
    {children}
  </Box>
);
